const rangesClose = (a, b, epsilon = 0.01) => {
  if (!a && !b) return true;
  if (!a || !b) return false;
  return (
    Math.abs(Number(a.from) - Number(b.from)) <= epsilon &&
    Math.abs(Number(a.to) - Number(b.to)) <= epsilon
  );
};

export const createSharedRangeBus = () => {
  let currentRange = null;
  let currentContext = null;
  const listeners = new Set();

  const notify = (range, sourceId) => {
    listeners.forEach((listener) => {
      try {
        listener(range, sourceId);
      } catch (_) {}
    });
  };

  return {
    getRange() {
      return currentRange;
    },
    getRangeSnapshot() {
      if (!currentRange) return null;
      return {
        range: { ...currentRange },
        pointCount: currentContext?.pointCount ?? null,
        scale: currentContext?.scale ?? null,
      };
    },
    setRange(range, sourceId = null, context = null) {
      const normalized =
        range &&
        Number.isFinite(range.from) &&
        Number.isFinite(range.to)
          ? { from: Number(range.from), to: Number(range.to) }
          : null;
      const normalizedContext = normalized
        ? {
            pointCount:
              Number.isFinite(Number(context?.pointCount)) &&
              Number(context.pointCount) > 0
                ? Number(context.pointCount)
                : null,
            scale:
              context?.scale != null && String(context.scale).trim()
                ? String(context.scale)
                : null,
          }
        : null;

      if (rangesClose(currentRange, normalized)) {
        currentContext = normalizedContext;
        return currentRange;
      }

      currentRange = normalized;
      currentContext = normalizedContext;
      notify(currentRange, sourceId);
      return currentRange;
    },
    clear(sourceId = null) {
      if (currentRange == null) return null;
      currentRange = null;
      currentContext = null;
      notify(null, sourceId);
      return null;
    },
    subscribe(listener) {
      if (typeof listener !== "function") {
        return () => {};
      }
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
};
